import { useTranslation } from "@sagot/i18n";
import { toast } from "@sagot/ui";
import { useNavigate } from "react-router";
import { integrationsHref } from "../../../lib/booking-links";
import { useWorkspaceContext } from "../../../session/workspace-context";
import type { IntegrationKey, SyncResult } from "./lead-types";

/**
 * Toast for `POST /v1/leads/sync`. The API reports counts and field codes only, so the message never
 * names a lead; a refused connection links to Settings > Integrations.
 */
export function useSyncResultToast(): (provider: IntegrationKey, result: SyncResult) => void {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { summary } = useWorkspaceContext();
  return (provider, result) => {
    const name = t(`engage.leads.crm.${provider}`);
    if (result.needs_reconnect) {
      toast.error(t("engage.leads.crm.needsReconnect", { provider: name }), {
        action: { label: t("engage.leads.crm.openIntegrations"), onClick: () => { void navigate(integrationsHref(summary.slug)); } },
      });
      return;
    }
    if (result.failed > 0) {
      toast.warning(t("engage.leads.crm.partial", { synced: result.synced, failed: result.failed, provider: name }));
      return;
    }
    toast.success(t("engage.leads.crm.synced", { count: result.synced, provider: name }));
  };
}
